import '@/styles/global.css';

import * as Sentry from '@sentry/react';
import { NuqsAdapter } from 'nuqs/adapters/react';

import { Toaster } from '@crehana/compass.ui/v3/toaster';
import { SPALayout } from '@crehana/layouts/spa/layout-with-centralized';

import { AddBaseFunctionality } from '@/shared/components/add-base-functionality';
import { Outlet, useParams } from '@/shared/modern-router';
import { useIsRenderedFromWebView } from '@crehana/react-hooks/use-is-rendered-from-webview';

import { HanaFloatingChatLazy } from '@crehana/hana-ai/floating-chat';

const App = () => {
  const { slug, orgSlug } = useParams();
  const isWebView = useIsRenderedFromWebView();

  return (
    <>
      <SPALayout
        sentryInstance={Sentry}
        organizationSlug={(slug || orgSlug) as string}
        intercomConfig={{
          enabled: !isWebView,
        }}
        renderCustomToaster={() => (
          // v3 Toaster ships with `tw-z-[9999]`, which sits below the legacy
          // dialog stack (`tw-z-dialog` = 16000001). Override to the
          // `snackbar` token so toasts always render above any open modal.
          <Toaster className="!tw-z-snackbar" />
        )}
      >
        <NuqsAdapter>
          <Outlet />
          <HanaFloatingChatLazy />
        </NuqsAdapter>
        <AddBaseFunctionality />
      </SPALayout>
    </>
  );
};

export default App;
